<template>
  <div class="col-12 px-0 mt-2">
    <form @submit.prevent="sendFilter" novalidate class="needs-validation d-flex mb-3 pt-3 p-1 p-sm-3 bg-lighter border-top">
      <label for="filter" class="sr-only">Advanced Filters</label>
      <div class="align-items-start d-flex flex-wrap w-100">
        <div class="px-md-3 pr-lg-0 mb-sm-3 mb-xl-2 col-12 col-md-6 col-lg-4 col-xl-3">
          <div class="form-group">
            <label for="startDate">Date&nbsp;<small>(from)</small></label>
            <input v-model="selectedFilter.from_date" :max="selectedFilter.to_date" :class="['form-control form-date w-100', errorStatus === 'validation_error' ? 'is-invalid' : '']" id="startDate" type="date" :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
            <div class="invalid-tooltip">
              <span v-if="selectedFilter.from_date > selectedFilter.to_date">Ensure the "from" date is before the "to" date.</span>
              <span v-else>Please include the Date{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</span>
            </div>
          </div>
        </div>
        <div class="mb-sm-4 mb-xl-2 px-md-3 col-12 col-md-6 col-lg-4 col-xl-3">
          <div class="form-group">
            <label for="endDate">Date&nbsp;<small>(to)</small></label>
            <input v-model="selectedFilter.to_date" :min="selectedFilter.from_date" :class="['form-control form-date w-100', errorStatus === 'validation_error' ? 'is-invalid' : '']" id="endDate" type="date" :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
            <div class="invalid-tooltip">
              <span v-if="selectedFilter.from_date > selectedFilter.to_date">Ensure the "from" date is before the "to" date.</span>
              <span v-else>Please include the Date{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</span>
            </div>
          </div>
        </div>
        <div class="form-group col-12 col-lg-auto px-lg-0">
          <label aria-hidden="true" class="w-100 d-none d-lg-block">&nbsp;</label>
          <button :class="['btn btn-block-mob mt-auto mx-lg-0 mb-3 mb-lg-4 mb-xl-2', processing ? 'btn-primary-dark' : 'btn-outline-primary']" type="submit" @click="handleSubmit">
            {{ !processing ? 'Filter' : '' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import VoerroTagsInput from '@voerro/vue-tagsinput'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'
import eventBus from '@/store/EventBus.js'

export default {
  props: ['errorStatus', 'loaded'],
  mixins: [HANDLESUBMIT, LEGACYBROWSERS],
  components: {
    'tags-input': VoerroTagsInput
  },
  data() {
    return {
      selectedFilter: {
        to_date: '',
        from_date: this.getDate()
      },
      processing: !this.loaded || false
    }
  },
  methods: {
    sendFilter() {
      this.processing = true
      eventBus.$emit('filterDate', this.selectedFilter)
    },
    getDate() {
      const d = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date()
      // 0 indexed for Jan so add 1 to get current
      const month = d.getMonth() + 1
      let year = d.getFullYear()
      // If the start of the year, subtract a year for last ACA year
      if (month <= 3) {
        year--
      }

      // Return the start of the ACA year
      return [year, `04`, `01`].join('-')
    }
  },
  mounted() {
    this.sendFilter()
  },
  watch: {
    loaded() {
      this.processing = !this.loaded
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/AdvancedFilter.vue